export const cashbackBrandAccent = '#57e3a4';
export const cashbackWhatsappGreen = '#25d366';
